import { z } from 'zod'

// single source of truth for the ISO date (YYYY-MM-DD) primitive used across
// the expenses-by-category query schemas; the regex catches obvious shape
// errors and the refine rejects nonsense like 2025-02-30.
export const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/

export const isoDate = z
  .string()
  .regex(ISO_DATE_RE, 'must be an ISO date (YYYY-MM-DD)')
  // Date silently rolls over invalid calendar days — Date.parse('2025-02-30…') is Mar 2, not NaN — so
  // round-trip the parsed Y/M/D through a UTC date and require the components to match. rejects
  // 2025-02-30 / 2025-04-31, accepts 2024-02-29 (leap). (#303)
  .refine((s) => {
    const [y, m, d] = s.split('-').map(Number)
    const dt = new Date(Date.UTC(y, m - 1, d))
    return dt.getUTCFullYear() === y && dt.getUTCMonth() + 1 === m && dt.getUTCDate() === d
  }, 'invalid date')
